import { render, staticRenderFns } from "./Family-statement-question-modal.vue?vue&type=template&id=47607e67"
import script from "./Family-statement-question-modal.vue?vue&type=script&lang=js"
export * from "./Family-statement-question-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports